import React from "react";
import cn from "classnames";
import { ElementProps } from "../../types";

export type LabelProps = ElementProps;

export const Label = <T extends LabelProps>(props: T) => {
  const { children, label, labelDescription, name, required, ...rest } =
    useLabelProps(props);

  return (
    <label
      className={cn({
        "form-label": true,
        required: required,
      })}
      htmlFor={name}
    >
      {children || label}
      {labelDescription && (
        <span className="form-label-description">{labelDescription}</span>
      )}
    </label>
  );
};

export default Label;

export const useLabelProps = <T extends ElementProps>({
  children,
  label,
  labelDescription,
  name,
  required,
}: T) => ({
  children,
  label,
  labelDescription,
  name,
  required,
});
